<template>
  <div class="pt-3 px-3">
    <ValidationObserver ref="form" tag="div" class="row">
      <div class="col-12 col-md-4">
        <ValidationProvider
          v-slot="{ errors, validate }"
          mode="lazy"
          rules="required"
          :custom-messages="{ required: 'Favor seleccione año academico.' }"
        >
          <CustomDropDown
            v-model="model.academicYear"
            :disabled="readonly"
            label="Año Académico:"
            regular-label
            fieldkey="id"
            fieldname="name"
            :options="catalog.academicYears"
            placeholder="Seleccione"
            :error="errors[0]"
            :custom-error-msg="errors[0]"
            @input="validate"
          />
        </ValidationProvider>
      </div>

      <div class="col-12 col-md-4">
        <ValidationProvider
          v-slot="{ errors, validate }"
          mode="lazy"
          rules="required"
          :custom-messages="{ required: 'Favor seleccione determinación.' }"
        >
          <CustomDropDown
            v-model="model.determination"
            :disabled="readonly"
            label="Determinación:"
            regular-label
            fieldkey="id"
            fieldname="name"
            :options="catalog.determinations"
            placeholder="Seleccione"
            :error="errors[0]"
            :custom-error-msg="errors[0]"
            @input="validate"
          />
        </ValidationProvider>
      </div>

      <div class="col-12 pt-2">
        <ValidationProvider
          v-slot="{ errors, validate }"
          mode="lazy"
          :rules="isCommentRequired ? 'required' : ''"
          :custom-messages="{ required: 'El comentario es requerido.' }"
        >
          <CustomTextArea
            v-model="model.reason"
            :disabled="readonly"
            label="Comentario:"
            regular-label
            :maxlength="3000"
            show-char-count
            :count-classes="['d-block text-right', 'small-counter']"
            :error="errors[0]"
            :custom-error-msg="errors[0]"
            @input="validate"
          />
        </ValidationProvider>
      </div>

      <div v-if="!readonly" class="col-12 pt-2 text-right">
        <ActionButton
          text="Cancelar"
          i="fas fa-times-circle"
          variant="custom-btn-return outline-danger"
          class="mr-2"
          @click="cancel"
        />
        <ActionButton
          text="Continuar"
          i="fas fa-arrow-alt-circle-right"
          variant="custom-btn-return outline-success"
          @click="submit"
        />
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import alert from '@/mixin/alert.mixin';

const initialModel = () => ({
  academicYear: null,
  determination: null,
  reason: null,
});

export default {
  name: 'ApprovalForm',
  mixins: [alert],
  components: {
    CustomDropDown,
    CustomTextArea,
    ActionButton,
  },
  props: {
    // { id: null, name: null, reason: null, reasonTypes: [] }
    currentStatus: {
      required: true,
      default: null,
      validator: (prop) => typeof prop === 'object' || prop === null,
    },
    currentStatusTarget: {
      required: true,
      default: null,
      validator: (prop) => typeof prop === 'object' || prop === null,
    },
    readonly: { type: Boolean, default: false },
    approvalAcademicYear: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      default: null,
    },
    approvalDetermination: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      default: null,
    },
    academicYearId: { type: Number, required: true, default: null },
  },
  data: () => ({
    model: initialModel(),
    catalog: {
      academicYears: [],
      determinations: [
        { id: 1, name: 'Compra de Servicio' },
        { id: 2, name: 'Reembolso' },
        { id: 3, name: 'Pago Directo' },
      ],
    },
  }),
  computed: {
    currentAcademicYear() {
      return this.catalog.academicYears.find((x) => x.isCurrentAcademicYear);
    },
    isCommentRequired() {
      return this.academicYearId != this.currentAcademicYear?.id;
    },
  },
  methods: {
    async getCatalog() {
      const { data: academicYears } = await this.$ApiGet(
        'api/academicyears/academicyearfromintotype?minYear=2021&yearType=FUTURE'
      );
      this.catalog.academicYears = academicYears.map(
        ({ id, description, selected }) => ({
          id,
          name: description,
          isCurrentAcademicYear: selected,
        })
      );
      this.model.academicYear = this.catalog.academicYears.find(
        (c) => c.id == this.academicYearId
      );
    },
    async submit() {
      if (this.readonly) return;
      const valid = await this.$refs['form'].validate();
      if (valid) {
        const model = {
          currentStatusTargetId: this.currentStatusTarget.id,
          model: this.model,
        };
        this.$emit('submit', model);
      } else {
        this.ShowToast(
          'Información Incompleta',
          'Favor de completar la información solicitada.',
          'error'
        );
      }
    },
    cancel() {
      this.model = initialModel();
      this.$refs['form'].reset();
      this.$emit('cancel');
    },
  },
  async created() {
    if (!this.readonly) {
      await this.getCatalog();
    }
    if (
      this.currentStatus &&
      this.approvalAcademicYear &&
      this.approvalDetermination
    ) {
      const { reason } = this.currentStatus;
      this.model = {
        academicYear: this.approvalAcademicYear,
        determination: this.approvalDetermination,
        reason,
      };
    }
    this.model.determination = this.approvalDetermination;
  },
};
</script>
